import { IAction, isType } from '@zaibot/fsa';
import MINIMIZE from './actions/NOTES_MINIMIZE';
import { INote, INoteShared } from '../../types';
import NOTES_ITEM_LAST_TOUCHED from './actions/NOTES_ITEM_LAST_TOUCHED';

import TOGGLE_NOTEMENU from './actions/NOTES_TOGGLE_NOTEMENU';
import NOTES_INITIALIZE from './actions/NOTES_INITIALIZE';
import NOTES_INSPECT from './actions/NOTES_INSPECT';
import SELECTION_CHAT from './actions/START_CHAT';
import STOP_CHAT from './actions/STOP_CHAT';
import ADMIN_SHOW from '../admin/actions/SHOW';
import NOTES_DELETE_BATCH_COMPLETE from './actions/NOTES_DELETE_BATCH_COMPLETE';
import NOTES_DELETE_BATCH from './actions/NOTES_DELETE_BATCH';
import NOTES_DELETE_BATCH_FAILURE from './actions/NOTES_DELETE_BATCH_FAILURE';
import NOTES_DELETE_BATCH_START from './actions/NOTES_DELETE_BATCH_START';
import NOTES_DELETE_BATCH_CANCEL from './actions/NOTES_DELETE_BATCH_CANCEL';

interface IState {
  showMiniMenu: boolean;
  noteselected: INote | INoteShared;
  minimized: boolean;
  initialize: boolean;
  inspect: INote | INoteShared;
  items: INote[];
  batchdelete: boolean;
}
const emptyState: IState = {
  showMiniMenu: false,
  noteselected: undefined,
  minimized: false,
  initialize: false,
  inspect: undefined,
  items: undefined,
  batchdelete: false,
};

export const selector = (state: any) => state.selection as IState;

export const reducer = (state = emptyState, action: IAction) => {
  if (isType(action, TOGGLE_NOTEMENU)) {
    return { ...state, showMiniMenu: action.payload.showMiniMenu, itemMiniMenu: action.payload.itemMiniMenu  };
  } 
  if (isType(action, NOTES_ITEM_LAST_TOUCHED)) {
    return { ...state, noteselected: action.payload.item  };
  }   
  if (isType(action, MINIMIZE)) {
    return { ...state, visible: true, minimized: action.payload.minimized};
  }       
  if (isType(action, NOTES_INITIALIZE)) {
    return { ...state, visible: true, initialize: action.payload.initialize};
  }
  if (isType(action, NOTES_INSPECT)) {
    return { ...state, inspect: action.payload.item};
  }  
  if (isType(action, ADMIN_SHOW)) {
    return { ...state, inspect: undefined};
  }
  if (isType(action, SELECTION_CHAT)) {
    return { ...state, inspect: action.payload.item};
  }  
  if (isType(action, STOP_CHAT)) {
    return { ...state, inspect: undefined};
  }   
  if (isType(action, NOTES_DELETE_BATCH)) {
    return { ...state, items: action.payload.items, batchdelete: true};
  }   
  if (isType(action, NOTES_DELETE_BATCH_COMPLETE)) {
    return { ...state, items: undefined, batchdelete: false};
  }   
  if (isType(action, NOTES_DELETE_BATCH_FAILURE)) {
    return { ...state, items: undefined, batchdelete: false};
  }  
  if (isType(action, NOTES_DELETE_BATCH_CANCEL)) {
    return { ...state, items: undefined, batchdelete: false};
  }  
  if (isType(action, NOTES_DELETE_BATCH_START)) {
    return { ...state, items: action.payload.items, batchdelete: true};
  } 
  return state;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notes/reducer.tsx